import type { RadioTabsShadowProps } from './const';

import { cn } from '@utils';
import './index.less';

export default function RadioTabsShadow(props: RadioTabsShadowProps) {
  const { direction, className } = props;

  return (
    <div className={cn('wg-radio-tabs-shadow', `wg-radio-tabs-shadow--${direction}`, className)} />
  );
}

export type { RadioTabsShadowProps };
